import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const TermsOfServicePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const lastUpdated = "January 15, 2026";

  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <Navbar />
      
      {/* Hero */}
      <section className="pt-32 pb-16 relative">
        <div className="absolute inset-0">
          <div className="grid-pattern opacity-30" />
        </div>
        <div className="container relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="max-w-4xl mx-auto"
          >
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Terms of Service</h1>
            <p className="text-white/60">Last updated: {lastUpdated}</p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="pb-24">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="max-w-4xl mx-auto prose prose-invert prose-lg"
          >
            <div className="space-y-8 text-white/80">
              <div>
                <h2 className="text-2xl font-bold text-white mb-4">1. Acceptance of Terms</h2>
                <p>
                  By accessing and using the OmniSportsGroup website and services, you accept and agree 
                  to be bound by these Terms of Service. If you do not agree to these terms, please do 
                  not use our services.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-white mb-4">2. Description of Services</h2>
                <p>
                  OmniSportsGroup provides sports technology platforms including OMNISCOUTING, OMNIAGENCY, 
                  and PLAYERSINC. These services are designed to help sports organizations, agencies, 
                  and athletes manage various aspects of athlete development, representation, and career management.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-white mb-4">3. User Responsibilities</h2>
                <p className="mb-4">When using our services, you agree to:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Provide accurate and complete information</li>
                  <li>Maintain the confidentiality of your account credentials</li>
                  <li>Use the services only for lawful purposes</li>
                  <li>Not attempt to interfere with or disrupt our services</li>
                  <li>Comply with all applicable laws and regulations</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-white mb-4">4. Intellectual Property</h2>
                <p>
                  All content, features, and functionality of our website and services, including but not 
                  limited to text, graphics, logos, and software, are owned by OmniSportsGroup and are 
                  protected by intellectual property laws. You may not reproduce, distribute, or create 
                  derivative works without our express written permission.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-white mb-4">5. Limitation of Liability</h2>
                <p>
                  To the fullest extent permitted by law, OmniSportsGroup shall not be liable for any 
                  indirect, incidental, special, consequential, or punitive damages arising out of or 
                  related to your use of our services. Our total liability shall not exceed the amount 
                  you paid us in the twelve months preceding the claim.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-white mb-4">6. Disclaimer of Warranties</h2>
                <p>
                  Our services are provided "as is" and "as available" without any warranties of any kind, 
                  either express or implied. We do not guarantee that our services will be uninterrupted, 
                  secure, or error-free.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-white mb-4">7. Modifications to Terms</h2>
                <p>
                  We reserve the right to modify these Terms of Service at any time. We will notify users 
                  of any material changes by posting the updated terms on our website. Your continued use 
                  of our services after such modifications constitutes acceptance of the updated terms.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-white mb-4">8. Governing Law</h2>
                <p>
                  These Terms of Service shall be governed by and construed in accordance with the laws 
                  of the United States, without regard to its conflict of law provisions.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-white mb-4">9. Contact Information</h2>
                <p>
                  For questions about these Terms of Service, please contact us at:
                </p>
                <p className="mt-4">
                  <strong className="text-white">Email:</strong>{' '}
                  <a href="mailto:info@omnisportsgroup.us" className="text-[#D3FF62] hover:underline">
                    info@omnisportsgroup.us
                  </a>
                </p>
              </div>

              <div className="pt-8 border-t border-white/10">
                <Link 
                  to="/" 
                  className="text-[#D3FF62] hover:underline inline-flex items-center gap-2"
                  onClick={() => window.scrollTo(0, 0)}
                >
                  ← Back to Home
                </Link>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TermsOfServicePage;
